var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["macros/navigation-items.j2"] = require( "macros/navigation-items.j2" );
dependencies["macros/contentful/navigation-treatment-macro.j2"] = require( "macros/contentful/navigation-treatment-macro.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/enhanced-tiered-navigation-macro.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/macros/enhanced-tiered-navigation-macro.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("categoryUrl")) {
var t_4 = t_1.categoryUrl;
} else {
cb(new Error("cannot import 'categoryUrl'")); return;
}
context.setVariable("categoryUrl", t_4);
output += "\n";
env.getTemplate("macros/navigation-items.j2", false, "core/templates/macros/enhanced-tiered-navigation-macro.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("renderNavItem")) {
var t_8 = t_5.renderNavItem;
} else {
cb(new Error("cannot import 'renderNavItem'")); return;
}
context.setVariable("renderNavItem", t_8);
output += "\n";
env.getTemplate("macros/contentful/navigation-treatment-macro.j2", false, "core/templates/macros/enhanced-tiered-navigation-macro.j2", false, function(t_10,t_9) {
if(t_10) { cb(t_10); return; }
t_9.getExported(function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
if(t_9.hasOwnProperty("generateTreatmentStyles")) {
var t_12 = t_9.generateTreatmentStyles;
} else {
cb(new Error("cannot import 'generateTreatmentStyles'")); return;
}
context.setVariable("generateTreatmentStyles", t_12);
output += "\n\n";
output += "\n\n";
var macro_t_13 = runtime.makeMacro(
["slugs"], 
["level", "levelLimit", "class"], 
function (l_slugs, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("slugs", l_slugs);
frame.set("level", kwargs.hasOwnProperty("level") ? kwargs["level"] : 3);
frame.set("levelLimit", kwargs.hasOwnProperty("levelLimit") ? kwargs["levelLimit"] : 3);
frame.set("class", kwargs.hasOwnProperty("class") ? kwargs["class"] : "");
var t_14 = "";t_14 += "\n\n    ";
t_14 += "\n    ";
if(runtime.contextOrFrameLookup(context, frame, "level") <= runtime.contextOrFrameLookup(context, frame, "levelLimit")) {
t_14 += "\n\n        <ul class=\"";
t_14 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__ul", env.opts.autoescape);
t_14 += " ";
t_14 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__ul--level", env.opts.autoescape);
t_14 += "-";
t_14 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_14 += "\" data-qa-main-navigation data-qa-main-navigation-level-";
t_14 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_14 += " data-child-slug-count=\"";
t_14 += runtime.suppressValue(env.getFilter("length").call(context, l_slugs), env.opts.autoescape);
t_14 += "\">\n\n        ";
frame = frame.push();
var t_17 = l_slugs;
if(t_17) {var t_16 = t_17.length;
for(var t_15=0; t_15 < t_17.length; t_15++) {
var t_18 = t_17[t_15];
frame.set("slug", t_18);
frame.set("loop.index", t_15 + 1);
frame.set("loop.index0", t_15);
frame.set("loop.revindex", t_16 - t_15);
frame.set("loop.revindex0", t_16 - t_15 - 1);
frame.set("loop.first", t_15 === 0);
frame.set("loop.last", t_15 === t_16 - 1);
frame.set("loop.length", t_16);
t_14 += "\n\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_18)) {
t_14 += "\n\n                ";
var t_19;
t_19 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_18);
frame.set("navItem", t_19, true);
if(frame.topLevel) {
context.setVariable("navItem", t_19);
}
if(frame.topLevel) {
context.addExport("navItem", t_19);
}
t_14 += "\n\n                    ";
t_14 += runtime.suppressValue((lineno = 134, colno = 68, runtime.callWrap(t_8, "renderNavItem", context, [runtime.contextOrFrameLookup(context, frame, "navItem"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_20 = runtime.makeMacro(
["currentNavItem", "url", "target"], 
[], 
function (l_currentNavItem, l_url, l_target, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("currentNavItem", l_currentNavItem);
frame.set("url", l_url);
frame.set("target", l_target);
var t_21 = "";t_21 += "\n\n                        ";
var t_22;
t_22 = "noopener noreferrer";
frame.set("rel", t_22, true);
if(frame.topLevel) {
context.setVariable("rel", t_22);
}
if(frame.topLevel) {
context.addExport("rel", t_22);
}
t_21 += "\n                        ";
var t_23;
t_23 = ((runtime.memberLookup((l_currentNavItem),"navigationDisplayPreferences") && runtime.memberLookup((runtime.memberLookup((l_currentNavItem),"navigationDisplayPreferences")),"displayAsSale") == runtime.contextOrFrameLookup(context, frame, "True")) && (runtime.memberLookup((l_currentNavItem),"nestLevel") < 3)?runtime.contextOrFrameLookup(context, frame, "True"):"");
frame.set("isSaleLink", t_23, true);
if(frame.topLevel) {
context.setVariable("isSaleLink", t_23);
}
if(frame.topLevel) {
context.addExport("isSaleLink", t_23);
}
t_21 += "\n\n                        <li class=\"";
t_21 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "isSaleLink")?"c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__sale":""), env.opts.autoescape);
t_21 += " ";
t_21 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__li", env.opts.autoescape);
t_21 += " ";
t_21 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__li--level", env.opts.autoescape);
t_21 += "-";
t_21 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_21 += "\">\n\n                            ";
var t_24;
t_24 = (lineno = 144, colno = 63, runtime.callWrap(t_4, "categoryUrl", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"slug")]));
frame.set("rootRelativePath", t_24, true);
if(frame.topLevel) {
context.setVariable("rootRelativePath", t_24);
}
if(frame.topLevel) {
context.addExport("rootRelativePath", t_24);
}
t_21 += "\n                            ";
var t_25;
t_25 = env.getFilter("sanitize_url").call(context, (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"urls")),"canonical") + "" + runtime.contextOrFrameLookup(context, frame, "rootRelativePath")));
frame.set("canonicalUrl", t_25, true);
if(frame.topLevel) {
context.setVariable("canonicalUrl", t_25);
}
if(frame.topLevel) {
context.addExport("canonicalUrl", t_25);
}
t_21 += "\n\n                            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"isContainer")) {
t_21 += "\n\n                                <span class=\"";
t_21 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__span", env.opts.autoescape);
t_21 += " ";
t_21 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a", env.opts.autoescape);
t_21 += " ";
t_21 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a--level", env.opts.autoescape);
t_21 += "-";
t_21 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_21 += "\">\n\n                                    ";
t_21 += runtime.suppressValue(runtime.memberLookup((l_currentNavItem),"displayName"), env.opts.autoescape);
t_21 += "\n\n                                </span>\n\n                            ";
;
}
else {
t_21 += "\n\n                                <a ";
if(l_target) {
t_21 += "target=\"";
t_21 += runtime.suppressValue(l_target, env.opts.autoescape);
t_21 += "\" ";
if(l_target == "_blank") {
t_21 += " rel=\"";
t_21 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "rel"), env.opts.autoescape);
t_21 += "\" ";
;
}
;
}
t_21 += "\n\n                                    ";
t_21 += runtime.suppressValue((lineno = 159, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [(lineno = 159, colno = 44, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.pageType",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey")])),"top_nav_l" + "" + runtime.contextOrFrameLookup(context, frame, "level") + "" + " click",runtime.memberLookup((l_currentNavItem),"gaLabel")])), env.opts.autoescape);
t_21 += "\n                                    class=\"";
t_21 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a", env.opts.autoescape);
t_21 += " ";
t_21 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a--level", env.opts.autoescape);
t_21 += "-";
t_21 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_21 += " ";
t_21 += runtime.suppressValue(((runtime.contextOrFrameLookup(context, frame, "level") == 1 && env.getFilter("length").call(context, runtime.memberLookup((l_currentNavItem),"childSlugs")) == 0)?"c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a--no-children":""), env.opts.autoescape);
t_21 += "\" href=\"";
t_21 += runtime.suppressValue(l_url, env.opts.autoescape);
t_21 += "\"  data-qa-main-navigation-link>\n\n                                    <span class=\"";
t_21 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__span", env.opts.autoescape);
t_21 += "\">";
t_21 += runtime.suppressValue(runtime.memberLookup((l_currentNavItem),"displayName"), env.opts.autoescape);
t_21 += "</span>\n\n                                </a>\n\n                            ";
;
}
t_21 += "\n\n                        </li>\n\n                    ";
;
frame = frame.pop();
return new runtime.SafeString(t_21);
});
return macro_t_20;})()})])), env.opts.autoescape);
t_14 += "\n\n            ";
;
}
t_14 += "\n\n        ";
;
}
}
frame = frame.pop();
t_14 += "\n\n        </ul>\n\n    ";
;
}
t_14 += "\n\n";
;
frame = frame.pop();
return new runtime.SafeString(t_14);
});
context.addExport("buildEnhancedTieredPrimaryNavigationLevel3");
context.setVariable("buildEnhancedTieredPrimaryNavigationLevel3", macro_t_13);
output += "\n\n";
var macro_t_26 = runtime.makeMacro(
["slugs"], 
["level", "levelLimit", "containerNavItem", "class", "forHover"], 
function (l_slugs, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("slugs", l_slugs);
frame.set("level", kwargs.hasOwnProperty("level") ? kwargs["level"] : 2);
frame.set("levelLimit", kwargs.hasOwnProperty("levelLimit") ? kwargs["levelLimit"] : 3);
frame.set("containerNavItem", kwargs.hasOwnProperty("containerNavItem") ? kwargs["containerNavItem"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("class", kwargs.hasOwnProperty("class") ? kwargs["class"] : "");
frame.set("forHover", kwargs.hasOwnProperty("forHover") ? kwargs["forHover"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_27 = "";t_27 += "\n\n    ";
t_27 += "\n    ";
if(runtime.contextOrFrameLookup(context, frame, "level") <= runtime.contextOrFrameLookup(context, frame, "levelLimit")) {
t_27 += "\n\n        <ul class=\"";
t_27 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__ul", env.opts.autoescape);
t_27 += " ";
t_27 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__ul--level", env.opts.autoescape);
t_27 += "-";
t_27 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_27 += " ";
if(runtime.contextOrFrameLookup(context, frame, "forHover")) {
t_27 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__ul--level-2-hover js-" + runtime.contextOrFrameLookup(context, frame, "class") + "__ul--level-2-hover", env.opts.autoescape);
;
}
t_27 += "\" data-child-slug-count=\"";
t_27 += runtime.suppressValue(env.getFilter("length").call(context, l_slugs), env.opts.autoescape);
t_27 += "\" data-qa-main-navigation data-qa-main-navigation-level-";
t_27 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_27 += ">\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "containerNavItem")) {
t_27 += "\n\n            <li class=\"";
if(!runtime.contextOrFrameLookup(context, frame, "forHover")) {
t_27 += " js-level2-nav-item ";
;
}
t_27 += " ";
t_27 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__li", env.opts.autoescape);
t_27 += " ";
t_27 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__li--level", env.opts.autoescape);
t_27 += "-";
t_27 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_27 += "\">\n\n                <span class=\"";
t_27 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__span", env.opts.autoescape);
t_27 += " ";
t_27 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a", env.opts.autoescape);
t_27 += " ";
t_27 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a--level", env.opts.autoescape);
t_27 += "-";
t_27 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_27 += "\">\n\n                    ";
t_27 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "containerNavItem")),"displayName"), env.opts.autoescape);
t_27 += "\n\n                </span>\n\n                ";
t_27 += runtime.suppressValue((lineno = 199, colno = 59, runtime.callWrap(macro_t_13, "buildEnhancedTieredPrimaryNavigationLevel3", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "containerNavItem")),"childSlugs"),runtime.makeKeywordArgs({"class": runtime.contextOrFrameLookup(context, frame, "class")})])), env.opts.autoescape);
t_27 += "\n\n            </li>\n\n        ";
;
}
t_27 += "\n\n        ";
frame = frame.push();
var t_30 = l_slugs;
if(t_30) {var t_29 = t_30.length;
for(var t_28=0; t_28 < t_30.length; t_28++) {
var t_31 = t_30[t_28];
frame.set("slug", t_31);
frame.set("loop.index", t_28 + 1);
frame.set("loop.index0", t_28);
frame.set("loop.revindex", t_29 - t_28);
frame.set("loop.revindex0", t_29 - t_28 - 1);
frame.set("loop.first", t_28 === 0);
frame.set("loop.last", t_28 === t_29 - 1);
frame.set("loop.length", t_29);
t_27 += "\n\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_31)) {
t_27 += "\n\n                ";
var t_32;
t_32 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_31);
frame.set("navItem", t_32, true);
if(frame.topLevel) {
context.setVariable("navItem", t_32);
}
if(frame.topLevel) {
context.addExport("navItem", t_32);
}
t_27 += "\n                ";
var t_33;
t_33 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"selectedLevel2NavSlug");
frame.set("selectedLevel2Slug", t_33, true);
if(frame.topLevel) {
context.setVariable("selectedLevel2Slug", t_33);
}
if(frame.topLevel) {
context.addExport("selectedLevel2Slug", t_33);
}
t_27 += "\n\n                    ";
t_27 += runtime.suppressValue((lineno = 212, colno = 68, runtime.callWrap(t_8, "renderNavItem", context, [runtime.contextOrFrameLookup(context, frame, "navItem"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_34 = runtime.makeMacro(
["currentNavItem", "url", "target"], 
[], 
function (l_currentNavItem, l_url, l_target, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("currentNavItem", l_currentNavItem);
frame.set("url", l_url);
frame.set("target", l_target);
var t_35 = "";t_35 += "\n\n                        ";
var t_36;
t_36 = "noopener noreferrer";
frame.set("rel", t_36, true);
if(frame.topLevel) {
context.setVariable("rel", t_36);
}
if(frame.topLevel) {
context.addExport("rel", t_36);
}
t_35 += "\n                        ";
var t_37;
t_37 = ((runtime.memberLookup((l_currentNavItem),"navigationDisplayPreferences") && runtime.memberLookup((runtime.memberLookup((l_currentNavItem),"navigationDisplayPreferences")),"displayAsSale") == runtime.contextOrFrameLookup(context, frame, "True")) && (runtime.memberLookup((l_currentNavItem),"nestLevel") < 3)?runtime.contextOrFrameLookup(context, frame, "True"):"");
frame.set("isSaleLink", t_37, true);
if(frame.topLevel) {
context.setVariable("isSaleLink", t_37);
}
if(frame.topLevel) {
context.addExport("isSaleLink", t_37);
}
t_35 += "\n\n                        <li class=\"";
if(!runtime.contextOrFrameLookup(context, frame, "forHover")) {
t_35 += " js-level2-nav-item ";
;
}
t_35 += " ";
t_35 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "isSaleLink")?"c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__sale":""), env.opts.autoescape);
t_35 += " ";
t_35 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__li", env.opts.autoescape);
t_35 += " ";
t_35 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__li--level", env.opts.autoescape);
t_35 += "-";
t_35 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_35 += "\">\n\n                            ";
var t_38;
t_38 = (lineno = 222, colno = 63, runtime.callWrap(t_4, "categoryUrl", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"slug")]));
frame.set("rootRelativePath", t_38, true);
if(frame.topLevel) {
context.setVariable("rootRelativePath", t_38);
}
if(frame.topLevel) {
context.addExport("rootRelativePath", t_38);
}
t_35 += "\n                            ";
var t_39;
t_39 = env.getFilter("sanitize_url").call(context, (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"urls")),"canonical") + "" + runtime.contextOrFrameLookup(context, frame, "rootRelativePath")));
frame.set("canonicalUrl", t_39, true);
if(frame.topLevel) {
context.setVariable("canonicalUrl", t_39);
}
if(frame.topLevel) {
context.addExport("canonicalUrl", t_39);
}
t_35 += "\n\n                            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"isContainer") && !runtime.contextOrFrameLookup(context, frame, "forHover")) {
t_35 += "\n\n                                <span class=\"";
t_35 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__span", env.opts.autoescape);
t_35 += " ";
t_35 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a", env.opts.autoescape);
t_35 += " ";
t_35 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a--level", env.opts.autoescape);
t_35 += "-";
t_35 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_35 += "\">\n\n                                    ";
t_35 += runtime.suppressValue(runtime.memberLookup((l_currentNavItem),"displayName"), env.opts.autoescape);
t_35 += "\n\n                                </span>\n\n                            ";
;
}
else {
t_35 += "\n\n                                <a ";
if(l_target) {
t_35 += "target=\"";
t_35 += runtime.suppressValue(l_target, env.opts.autoescape);
t_35 += "\" ";
if(l_target == "_blank") {
t_35 += " rel=\"";
t_35 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "rel"), env.opts.autoescape);
t_35 += "\" ";
;
}
;
}
t_35 += "\n\n                                    ";
t_35 += runtime.suppressValue((lineno = 237, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [(lineno = 237, colno = 44, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.pageType",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey")])),"top_nav_l" + "" + runtime.contextOrFrameLookup(context, frame, "level") + "" + " click",runtime.memberLookup((l_currentNavItem),"gaLabel")])), env.opts.autoescape);
t_35 += "\n                                    class=\"";
t_35 += runtime.suppressValue(((t_31 == runtime.contextOrFrameLookup(context, frame, "selectedLevel2Slug"))?"is-selected":""), env.opts.autoescape);
t_35 += " ";
t_35 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a", env.opts.autoescape);
t_35 += " ";
t_35 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a--level", env.opts.autoescape);
t_35 += "-";
t_35 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_35 += " ";
t_35 += runtime.suppressValue(((runtime.contextOrFrameLookup(context, frame, "level") == 1 && env.getFilter("length").call(context, runtime.memberLookup((l_currentNavItem),"childSlugs")) == 0)?"c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a--no-children":""), env.opts.autoescape);
t_35 += "\" href=\"";
t_35 += runtime.suppressValue(l_url, env.opts.autoescape);
t_35 += "\" data-qa-main-navigation-link>\n\n                                    <span class=\"";
t_35 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__span", env.opts.autoescape);
t_35 += "\">";
t_35 += runtime.suppressValue(runtime.memberLookup((l_currentNavItem),"displayName"), env.opts.autoescape);
t_35 += "</span>\n\n                                </a>\n\n                            ";
;
}
t_35 += "\n\n                            ";
t_35 += "\n                            ";
if(!runtime.contextOrFrameLookup(context, frame, "forHover") && runtime.contextOrFrameLookup(context, frame, "level") == 2 && runtime.memberLookup((l_currentNavItem),"childSlugs") && env.getFilter("length").call(context, runtime.memberLookup((l_currentNavItem),"childSlugs")) > 0) {
t_35 += "\n\n                                ";
t_35 += runtime.suppressValue((lineno = 249, colno = 75, runtime.callWrap(macro_t_13, "buildEnhancedTieredPrimaryNavigationLevel3", context, [runtime.memberLookup((l_currentNavItem),"childSlugs"),runtime.makeKeywordArgs({"class": runtime.contextOrFrameLookup(context, frame, "class")})])), env.opts.autoescape);
t_35 += "\n\n                            ";
;
}
t_35 += "\n\n                        </li>\n\n                    ";
;
frame = frame.pop();
return new runtime.SafeString(t_35);
});
return macro_t_34;})()})])), env.opts.autoescape);
t_27 += "\n\n            ";
;
}
t_27 += "\n\n        ";
;
}
}
frame = frame.pop();
t_27 += "\n\n        </ul>\n\n    ";
;
}
t_27 += "\n\n";
;
frame = frame.pop();
return new runtime.SafeString(t_27);
});
context.addExport("buildEnhancedTieredPrimaryNavigationLevel2");
context.setVariable("buildEnhancedTieredPrimaryNavigationLevel2", macro_t_26);
var macro_t_40 = runtime.makeMacro(
["slugs"], 
["level", "levelLimit", "selectedLevel1Slug", "class"], 
function (l_slugs, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("slugs", l_slugs);
frame.set("level", kwargs.hasOwnProperty("level") ? kwargs["level"] : 1);
frame.set("levelLimit", kwargs.hasOwnProperty("levelLimit") ? kwargs["levelLimit"] : 3);
frame.set("selectedLevel1Slug", kwargs.hasOwnProperty("selectedLevel1Slug") ? kwargs["selectedLevel1Slug"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("class", kwargs.hasOwnProperty("class") ? kwargs["class"] : "");
var t_41 = "";t_41 += "\n\n    ";
t_41 += "\n    ";
if(runtime.contextOrFrameLookup(context, frame, "level") <= runtime.contextOrFrameLookup(context, frame, "levelLimit")) {
t_41 += "\n\n    ";
var t_42;
t_42 = ((runtime.contextOrFrameLookup(context, frame, "level") == 1)?runtime.contextOrFrameLookup(context, frame, "True"):runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("islevelOne", t_42, true);
if(frame.topLevel) {
context.setVariable("islevelOne", t_42);
}
if(frame.topLevel) {
context.addExport("islevelOne", t_42);
}
t_41 += "\n    ";
var t_43;
t_43 = (runtime.inOperator(runtime.contextOrFrameLookup(context, frame, "selectedLevel1Slug"),(lineno = 290, colno = 64, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "core"),"categoryRootNavSlugs",{}])))?runtime.contextOrFrameLookup(context, frame, "True"):"");
frame.set("hasSubnav", t_43, true);
if(frame.topLevel) {
context.setVariable("hasSubnav", t_43);
}
if(frame.topLevel) {
context.addExport("hasSubnav", t_43);
}
t_41 += "\n    ";
var t_44;
t_44 = (lineno = 291, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.featureConfigs.headerFeatureConfig.navigationTreatmentContainer",[]]));
frame.set("navigationTreatments", t_44, true);
if(frame.topLevel) {
context.setVariable("navigationTreatments", t_44);
}
if(frame.topLevel) {
context.addExport("navigationTreatments", t_44);
}
t_41 += "\n    ";
var t_45;
t_45 = (runtime.contextOrFrameLookup(context, frame, "islevelOne") && !runtime.contextOrFrameLookup(context, frame, "hasLargeHideClass") && env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "navigationTreatments")) > 0?runtime.contextOrFrameLookup(context, frame, "True"):"");
frame.set("treatmentsAvailable", t_45, true);
if(frame.topLevel) {
context.setVariable("treatmentsAvailable", t_45);
}
if(frame.topLevel) {
context.addExport("treatmentsAvailable", t_45);
}
t_41 += "\n    ";
var t_46;
t_46 = (runtime.contextOrFrameLookup(context, frame, "treatmentsAvailable")?"navigation-treatment-":"");
frame.set("idPrefix", t_46, true);
if(frame.topLevel) {
context.setVariable("idPrefix", t_46);
}
if(frame.topLevel) {
context.addExport("idPrefix", t_46);
}
t_41 += "\n\n    ";
t_41 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "treatmentsAvailable")?(lineno = 295, colno = 28, runtime.callWrap(t_12, "generateTreatmentStyles", context, [runtime.contextOrFrameLookup(context, frame, "idPrefix"),runtime.contextOrFrameLookup(context, frame, "navigationTreatments")])):""), env.opts.autoescape);
t_41 += "\n\n        <ul class=\"";
t_41 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__ul", env.opts.autoescape);
t_41 += " ";
t_41 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__ul--level", env.opts.autoescape);
t_41 += "-";
t_41 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_41 += " ";
t_41 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "hasSubnav")?"has-subnav":""), env.opts.autoescape);
t_41 += "\" ";
if(runtime.contextOrFrameLookup(context, frame, "islevelOne")) {
t_41 += "itemscope itemtype=\"http://www.schema.org/SiteNavigationElement\"";
;
}
t_41 += " data-qa-main-navigation data-qa-main-navigation-level-";
t_41 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_41 += ">\n\n        ";
frame = frame.push();
var t_49 = l_slugs;
if(t_49) {var t_48 = t_49.length;
for(var t_47=0; t_47 < t_49.length; t_47++) {
var t_50 = t_49[t_47];
frame.set("slug", t_50);
frame.set("loop.index", t_47 + 1);
frame.set("loop.index0", t_47);
frame.set("loop.revindex", t_48 - t_47);
frame.set("loop.revindex0", t_48 - t_47 - 1);
frame.set("loop.first", t_47 === 0);
frame.set("loop.last", t_47 === t_48 - 1);
frame.set("loop.length", t_48);
t_41 += "\n\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_50)) {
t_41 += "\n\n                ";
var t_51;
t_51 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_50);
frame.set("navItem", t_51, true);
if(frame.topLevel) {
context.setVariable("navItem", t_51);
}
if(frame.topLevel) {
context.addExport("navItem", t_51);
}
t_41 += "\n                ";
var t_52;
t_52 = (runtime.contextOrFrameLookup(context, frame, "treatmentsAvailable") && (lineno = 304, colno = 76, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.navigationTreatmentListing." + "" + t_50]))?runtime.contextOrFrameLookup(context, frame, "True"):runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("slugHasTreatment", t_52, true);
if(frame.topLevel) {
context.setVariable("slugHasTreatment", t_52);
}
if(frame.topLevel) {
context.addExport("slugHasTreatment", t_52);
}
t_41 += "\n                ";
var t_53;
t_53 = (runtime.contextOrFrameLookup(context, frame, "slugHasTreatment")?"id=" + "" + runtime.contextOrFrameLookup(context, frame, "idPrefix") + "" + t_50:"");
frame.set("treatmentId", t_53, true);
if(frame.topLevel) {
context.setVariable("treatmentId", t_53);
}
if(frame.topLevel) {
context.addExport("treatmentId", t_53);
}
t_41 += "\n\n                    ";
t_41 += runtime.suppressValue((lineno = 307, colno = 68, runtime.callWrap(t_8, "renderNavItem", context, [runtime.contextOrFrameLookup(context, frame, "navItem"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_54 = runtime.makeMacro(
["currentNavItem", "url", "target"], 
[], 
function (l_currentNavItem, l_url, l_target, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("currentNavItem", l_currentNavItem);
frame.set("url", l_url);
frame.set("target", l_target);
var t_55 = "";t_55 += "\n\n                        ";
var t_56;
t_56 = "noopener noreferrer";
frame.set("rel", t_56, true);
if(frame.topLevel) {
context.setVariable("rel", t_56);
}
if(frame.topLevel) {
context.addExport("rel", t_56);
}
t_55 += "\n                        ";
var t_57;
t_57 = ((runtime.memberLookup((l_currentNavItem),"navigationDisplayPreferences") && runtime.memberLookup((runtime.memberLookup((l_currentNavItem),"navigationDisplayPreferences")),"displayAsSale") == runtime.contextOrFrameLookup(context, frame, "True")) && (runtime.memberLookup((l_currentNavItem),"nestLevel") < 3)?runtime.contextOrFrameLookup(context, frame, "True"):"");
frame.set("isSaleLink", t_57, true);
if(frame.topLevel) {
context.setVariable("isSaleLink", t_57);
}
if(frame.topLevel) {
context.addExport("isSaleLink", t_57);
}
t_55 += "\n\n                        <li class=\"";
t_55 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "isSaleLink")?"c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__sale":""), env.opts.autoescape);
t_55 += " ";
t_55 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__li", env.opts.autoescape);
t_55 += " ";
t_55 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__li--level", env.opts.autoescape);
t_55 += "-";
t_55 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_55 += " js-level1-nav-item\" data-slug=\"";
t_55 += runtime.suppressValue(t_50, env.opts.autoescape);
t_55 += "\">\n\n                            ";
var t_58;
t_58 = (lineno = 317, colno = 63, runtime.callWrap(t_4, "categoryUrl", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"slug")]));
frame.set("rootRelativePath", t_58, true);
if(frame.topLevel) {
context.setVariable("rootRelativePath", t_58);
}
if(frame.topLevel) {
context.addExport("rootRelativePath", t_58);
}
t_55 += "\n                            ";
var t_59;
t_59 = env.getFilter("sanitize_url").call(context, (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"urls")),"canonical") + "" + runtime.contextOrFrameLookup(context, frame, "rootRelativePath")));
frame.set("canonicalUrl", t_59, true);
if(frame.topLevel) {
context.setVariable("canonicalUrl", t_59);
}
if(frame.topLevel) {
context.addExport("canonicalUrl", t_59);
}
t_55 += "\n\n                            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"isContainer")) {
t_55 += "\n\n                                <span class=\"";
t_55 += runtime.suppressValue("c-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__span", env.opts.autoescape);
t_55 += " ";
t_55 += runtime.suppressValue("c-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__a", env.opts.autoescape);
t_55 += " ";
t_55 += runtime.suppressValue("c-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__a--level-" + "" + runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_55 += "\" ";
t_55 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "treatmentId"), env.opts.autoescape);
t_55 += ">\n\n                                    ";
t_55 += runtime.suppressValue(runtime.memberLookup((l_currentNavItem),"displayName"), env.opts.autoescape);
t_55 += "\n\n                                </span>\n\n                            ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "level") == 1 && env.getFilter("length").call(context, runtime.memberLookup((l_currentNavItem),"childSlugs")) > 0) {
t_55 += "\n\n                                <a\n                                    ";
t_55 += runtime.suppressValue((lineno = 331, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [(lineno = 331, colno = 44, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.pageType",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey")])),"top_nav_l" + "" + runtime.contextOrFrameLookup(context, frame, "level") + "" + " click",runtime.memberLookup((l_currentNavItem),"gaLabel")])), env.opts.autoescape);
t_55 += " ";
t_55 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "treatmentId"), env.opts.autoescape);
t_55 += "\n                                    class=\"";
t_55 += runtime.suppressValue(((t_50 == runtime.contextOrFrameLookup(context, frame, "selectedLevel1Slug"))?"is-selected":""), env.opts.autoescape);
t_55 += " ";
t_55 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a", env.opts.autoescape);
t_55 += " ";
t_55 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a--level", env.opts.autoescape);
t_55 += "-";
t_55 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_55 += "\" href=\"";
t_55 += runtime.suppressValue(l_url, env.opts.autoescape);
t_55 += "\" ";
if(runtime.contextOrFrameLookup(context, frame, "islevelOne")) {
t_55 += "itemprop=\"url\"";
;
}
t_55 += " data-qa-main-navigation-link>\n\n                                    <span class=\"";
t_55 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__span", env.opts.autoescape);
t_55 += "\" ";
if(runtime.contextOrFrameLookup(context, frame, "islevelOne")) {
t_55 += "itemprop=\"name\"";
;
}
t_55 += ">";
t_55 += runtime.suppressValue(runtime.memberLookup((l_currentNavItem),"displayName"), env.opts.autoescape);
t_55 += "</span>\n\n                                </a>\n\n                            ";
;
}
else {
t_55 += "\n\n                                <a ";
if(l_target) {
t_55 += "target=\"";
t_55 += runtime.suppressValue(l_target, env.opts.autoescape);
t_55 += "\" ";
if(l_target == "_blank") {
t_55 += " rel=\"";
t_55 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "rel"), env.opts.autoescape);
t_55 += "\" ";
;
}
;
}
t_55 += "\n\n                                    ";
t_55 += runtime.suppressValue((lineno = 342, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [(lineno = 342, colno = 44, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.pageType",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey")])),"top_nav_l" + "" + runtime.contextOrFrameLookup(context, frame, "level") + "" + " click",runtime.memberLookup((l_currentNavItem),"gaLabel")])), env.opts.autoescape);
t_55 += " ";
t_55 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "treatmentId"), env.opts.autoescape);
t_55 += "\n                                    class=\"";
t_55 += runtime.suppressValue(((t_50 == runtime.contextOrFrameLookup(context, frame, "selectedLevel1Slug"))?"is-selected":""), env.opts.autoescape);
t_55 += " ";
t_55 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a", env.opts.autoescape);
t_55 += " ";
t_55 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a--level", env.opts.autoescape);
t_55 += "-";
t_55 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_55 += " ";
t_55 += runtime.suppressValue(((runtime.contextOrFrameLookup(context, frame, "level") == 1 && env.getFilter("length").call(context, runtime.memberLookup((l_currentNavItem),"childSlugs")) == 0)?"c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a--no-children":""), env.opts.autoescape);
t_55 += "\" href=\"";
t_55 += runtime.suppressValue(l_url, env.opts.autoescape);
t_55 += "\" ";
if(runtime.contextOrFrameLookup(context, frame, "islevelOne")) {
t_55 += "itemprop=\"url\"";
;
}
t_55 += " data-qa-main-navigation-link>\n\n                                    <span class=\"";
t_55 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__span", env.opts.autoescape);
t_55 += "\" ";
if(runtime.contextOrFrameLookup(context, frame, "islevelOne")) {
t_55 += "itemprop=\"name\"";
;
}
t_55 += ">";
t_55 += runtime.suppressValue(runtime.memberLookup((l_currentNavItem),"displayName"), env.opts.autoescape);
t_55 += "</span>\n\n                                </a>\n\n                            ";
;
}
;
}
t_55 += "\n\n                            ";
t_55 += runtime.suppressValue((lineno = 351, colno = 71, runtime.callWrap(macro_t_26, "buildEnhancedTieredPrimaryNavigationLevel2", context, [runtime.memberLookup((l_currentNavItem),"childSlugs"),runtime.makeKeywordArgs({"containerNavItem": runtime.contextOrFrameLookup(context, frame, "containerNavItem"),"class": runtime.contextOrFrameLookup(context, frame, "class"),"forHover": runtime.contextOrFrameLookup(context, frame, "True")})])), env.opts.autoescape);
t_55 += "\n\n                        </li>\n\n                    ";
;
frame = frame.pop();
return new runtime.SafeString(t_55);
});
return macro_t_54;})()})])), env.opts.autoescape);
t_41 += "\n\n            ";
;
}
t_41 += "\n\n        ";
;
}
}
frame = frame.pop();
t_41 += "\n\n        </ul>\n\n        ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_large") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_extra_large")) {
t_41 += "\n            <span class=\"js-nav-slide-line c-main-navigation__slide-line\"></span>\n        ";
;
}
t_41 += "\n\n    ";
;
}
t_41 += "\n\n    ";
t_41 += "\n    ";
if((runtime.contextOrFrameLookup(context, frame, "level") == 1 && runtime.inOperator(runtime.contextOrFrameLookup(context, frame, "selectedLevel1Slug"),l_slugs))) {
t_41 += "\n        ";
var t_60;
t_60 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),runtime.contextOrFrameLookup(context, frame, "selectedLevel1Slug"));
frame.set("selectedNavItem", t_60, true);
if(frame.topLevel) {
context.setVariable("selectedNavItem", t_60);
}
if(frame.topLevel) {
context.addExport("selectedNavItem", t_60);
}
t_41 += "\n\n        ";
t_41 += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "selectedNavItem")) {
t_41 += "\n            ";
var t_61;
t_61 = (env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "selectedNavItem")),"containerInfo")) > 0?runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "selectedNavItem")),"containerInfo")),0):runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("selectedFeatureSlug", t_61, true);
if(frame.topLevel) {
context.setVariable("selectedFeatureSlug", t_61);
}
if(frame.topLevel) {
context.addExport("selectedFeatureSlug", t_61);
}
t_41 += "\n        ";
;
}
t_41 += "\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "selectedFeatureSlug")) {
t_41 += "\n            ";
var t_62;
t_62 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),runtime.contextOrFrameLookup(context, frame, "selectedFeatureSlug")) || runtime.contextOrFrameLookup(context, frame, "None");
frame.set("containerNavItem", t_62, true);
if(frame.topLevel) {
context.setVariable("containerNavItem", t_62);
}
if(frame.topLevel) {
context.addExport("containerNavItem", t_62);
}
t_41 += "\n        ";
;
}
t_41 += "\n\n        ";
t_41 += runtime.suppressValue((lineno = 382, colno = 51, runtime.callWrap(macro_t_26, "buildEnhancedTieredPrimaryNavigationLevel2", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "selectedNavItem")),"childSlugs"),runtime.makeKeywordArgs({"containerNavItem": runtime.contextOrFrameLookup(context, frame, "containerNavItem"),"class": runtime.contextOrFrameLookup(context, frame, "class")})])), env.opts.autoescape);
t_41 += "\n\n    ";
;
}
t_41 += "\n\n";
;
frame = frame.pop();
return new runtime.SafeString(t_41);
});
context.addExport("buildEnhancedTieredPrimaryNavigation");
context.setVariable("buildEnhancedTieredPrimaryNavigation", macro_t_40);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/enhanced-tiered-navigation-macro.j2"] , dependencies)